import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ChatService } from '../services/chat.service';

const escapeHtml = (text: string): string =>
  text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

@Pipe({
  standalone: true,
  name: 'chatEmote',
})
export class ChatEmotePipe implements PipeTransform {
  constructor(
    private chatService: ChatService,
    private sanitizer: DomSanitizer
  ) {}

  transform(content: string, level: number): SafeHtml {
    let html = escapeHtml(content ?? '');

    for (const emote of this.chatService.emotes()) {
      if (emote.level > level) {
        continue;
      }

      const regex = new RegExp(`:${emote.key}:`, 'g');
      html = html.replace(
        regex,
        `<img src="${emote.image}" alt="${emote.key}" style="width:22px;height:22px;display:inline-flex;align-items:center;vertical-align:middle;">`
      );
    }

    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
